import { compose } from 'redux';

import {
    WithStatelessDatasFetchingByParameters,
    WithNotifyRessourceLoaded,
    WithNotifyRessourceLoadedInputProps,
} from 'modules/shared/hocs';
import { NavigationElement } from 'modules/shared/models';
import { cacheQueryService } from 'modules/shared/services';

import { WithCatalogueSEO } from '../../hocs';
import { getParentNavigation } from '../../utils';
import { categoryService } from '../../services';
import { Category, GetCategory } from '../../models';

import { CategoryProps } from './category-type';
import { CategoryLoader } from './category-loader';

const getRessourceName = (props?: CategoryProps): string | undefined => {
    if (props && props.category) {
        return props.category.name;
    }

    return undefined;
};

const getAdditionalParentTree = (
    props?: CategoryProps,
    parentNavigationTree?: NavigationElement,
): NavigationElement | undefined => {
    if (props && props.category) {
        return getParentNavigation(props.category, parentNavigationTree);
    }

    return undefined;
};

const enhancer = compose<React.ComponentType<GetCategory & WithNotifyRessourceLoadedInputProps>>(
    WithStatelessDatasFetchingByParameters<Category, CategoryProps, GetCategory>(
        cacheQueryService.cacheWithParams('getCategory', categoryService.get),
        CategoryLoader,
        'redirect',
        'category',
        ['id'],
    ),
    WithNotifyRessourceLoaded(getRessourceName, getAdditionalParentTree),
    WithCatalogueSEO<CategoryProps>('category'),
);
export default enhancer;
